import React, { FC, useContext } from "react";
import {
  ClaimsActivityDashboardContext,
  ClaimsActivityDashboardContextProvider,
  ClaimsActivityDashboardDefaultView,
  ClaimsActivityDownloadGhostProviders,
  ClaimsActivityDashboardScenarioView,
} from "@app/projects/network-assessment/pci-dashboard/claims-activity";
import { PciDashboardFilters, PciDashboardFiltersContext, PciDashboardFiltersContextProvider, PciDashboardWrapper } from "@app/projects/network-assessment/pci-dashboard/shared";

export const WrappedClaimsActivity: React.FC<React.PropsWithChildren<unknown>> = () => {
  const claimsActivityContext = useContext(ClaimsActivityDashboardContext);
  const pciDashboardFiltersContext = useContext(PciDashboardFiltersContext);

  return (
    <PciDashboardWrapper
      showLineOfBusiness={true}
    >
      <div className="row">
        <div className="col-12">
          <ClaimsActivityDownloadGhostProviders />
        </div>
      </div>
      <PciDashboardFilters
        isLoading={
          claimsActivityContext.networkProvidersSummariesLoading ||
          claimsActivityContext.marketProvidersSummariesLoading ||
          claimsActivityContext.prospectProvidersSummariesLoading ||
          claimsActivityContext.topGhostProviderCountiesLoading ||
          claimsActivityContext.topGhostProviderSpecialtiesLoading
        }
        isPca={true}
        onApplyFiltersClick={claimsActivityContext.onApplyFiltersClick}
        showLineOfBusiness={true}
      />
      {pciDashboardFiltersContext?.displayedFilters?.compareTimeslices ? (
        <ClaimsActivityDashboardScenarioView />
      ): (
        <ClaimsActivityDashboardDefaultView />
      )}
    </PciDashboardWrapper>
  );
}

const ClaimsActivity: FC = () => (
  <PciDashboardFiltersContextProvider>
    <ClaimsActivityDashboardContextProvider>
      <WrappedClaimsActivity />
    </ClaimsActivityDashboardContextProvider>
  </PciDashboardFiltersContextProvider>
);

export default ClaimsActivity;
